import { useNavigation } from "@react-navigation/native";
import { Home } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React, { type PropsWithChildren } from "react";
import { getTokenValue, updateTheme, View, XStack, YStack } from "tamagui";
import { useApi } from "../../core/apis";
import { useStores } from "../../core/stores";
import { Box } from "../../ui/Box";
import { ImageFit } from "../../ui/ImageFit";
import { FullScreenLoading } from "../../ui/Loading";
import { Title } from "../../ui/Title";
import BusinessAdminGate from "./BusinessAdminGate";

export const BusinessAdminView = observer(
  ({ customerUid, children }: PropsWithChildren & { customerUid: string }) => {
    const { businessCustomersStore } = useStores();
    const { businessCustomersApi } = useApi();

    const { navigate } = useNavigation();
    const customer = businessCustomersStore.byId.get(customerUid);

    React.useEffect(() => {
      return businessCustomersApi.watchItem(customerUid);
    }, [businessCustomersApi, customerUid]);

    const theme = customer?.data.profile.theme;
    const showImage = customer?.data.profile.logoUrl;

    React.useEffect(() => {
      updateTheme({
        name: "light",
        theme: {
          pressablePrimaryLabel:
            theme?.pressablePrimaryLabel ??
            getTokenValue("$pressablePrimaryLabel"),
          pressablePrimaryBackground:
            theme?.pressablePrimaryBackground ??
            getTokenValue("$pressablePrimaryBackground"),
        },
      });
    }, [theme]);

    if (!customer) {
      return <FullScreenLoading />;
    }

    return (
      <BusinessAdminGate customer={customer}>
        <YStack gap={"$medium"} width={"100%"}>
          <Box>
            <XStack justifyContent={"space-between"} width={"100%"}>
              <XStack
                cursor={"pointer"}
                alignItems={"center"}
                gap={"$medium"}
                onPress={() =>
                  navigate("CustomerAdmin", {
                    customerUid: customerUid,
                  })
                }
              >
                <Home />
                <Title>Admin - {customer.data.profile.name}</Title>
              </XStack>

              {!!showImage && (
                <View>
                  <ImageFit height={35} assetUrl={showImage} />
                </View>
              )}
            </XStack>
          </Box>

          {children}
        </YStack>
      </BusinessAdminGate>
    );
  },
);
